import React from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack, IoChevronUp } from "react-icons/io5";

const EARLY_ACCESS_IMAGES = [
    {
        src: "https://images.unsplash.com/photo-1525253086316-d0c936c814f8?auto=format&fit=crop&w=900&q=80",
        alt: "Dog resting indoors",
    },
    {
        src: "https://images.unsplash.com/photo-1527631746610-bca00a040d60?auto=format&fit=crop&w=900&q=80",
        alt: "Friends sitting in the back of a car",
    },
    {
        src: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&w=900&q=80",
        alt: "Theme park crowd in front of a castle",
    },
];

const GetEarlyAccess = () => {
    const navigate = useNavigate();
    const openWaitlistSidebar = () => {
        window.dispatchEvent(new Event("open-waitlist-sidebar"));
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <section className="relative flex h-full w-full flex-col overflow-hidden">
            {/* Back arrow — mobile only */}
            <button
                onClick={() => navigate(-1)}
                className="flex md:hidden items-center gap-1.5 px-6 pt-6"
            >
                <IoArrowBack className="text-[22px]" />
            </button>

            <div className="flex flex-1 flex-col gap-10 overflow-y-auto px-6 py-8 sm:px-10 lg:px-14 lg:py-10 no-scrollbar">
                <div className="flex flex-1 flex-col gap-10 lg:flex-row lg:items-center lg:justify-start lg:gap-12">
                    <div className="flex max-w-[420px] flex-col pt-2 lg:pt-0">
                        <div className="w-fit rounded-[14px] border border-[#7FC7E6] px-6 py-3">
                            <span className="text-[15px] font-semibold text-[#139AC3]">
                                Get early access
                            </span>
                        </div>

                        <h2 className="mt-9 text-[48px] font-black leading-[1.05] text-[#202020]">
                            Be part of the early
                            <br />
                            community.
                        </h2>

                        <button
                            type="button"
                            onClick={openWaitlistSidebar}
                            className="mt-10 h-14 w-fit rounded-2xl bg-[#BEE6FF] px-9 text-[18px] font-semibold text-black"
                        >
                            Join our waitlist
                        </button>
                    </div>

                    <div className="flex items-center justify-center lg:justify-end">
                        <div className="grid w-full max-w-[520px] grid-cols-2 gap-4 sm:gap-5 lg:w-auto">
                            <div className="order-2 flex items-center justify-center lg:order-1 lg:pr-1">
                                <img
                                    src={EARLY_ACCESS_IMAGES[0].src}
                                    alt={EARLY_ACCESS_IMAGES[0].alt}
                                    className="h-[320px] w-[220px] rounded-[30px] object-cover shadow-[0_18px_40px_rgba(0,0,0,0.12)]"
                                    draggable={false}
                                />
                            </div>

                            <div className="order-1 flex flex-col gap-4 sm:gap-5 lg:order-2">
                                <img
                                    src={EARLY_ACCESS_IMAGES[1].src}
                                    alt={EARLY_ACCESS_IMAGES[1].alt}
                                    className="h-[300px] w-[220px] rounded-[30px] object-cover shadow-[0_18px_40px_rgba(0,0,0,0.12)]"
                                    draggable={false}
                                />
                                <img
                                    src={EARLY_ACCESS_IMAGES[2].src}
                                    alt={EARLY_ACCESS_IMAGES[2].alt}
                                    className="h-[340px] w-[220px] rounded-[30px] object-cover shadow-[0_18px_40px_rgba(0,0,0,0.12)]"
                                    draggable={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-center pb-1">
                    <button
                        type="button"
                        onClick={scrollToTop}
                        className="flex items-center gap-2 text-[15px] font-semibold text-[#2E9DDA] transition-opacity hover:opacity-80"
                    >
                        Back to top
                        <IoChevronUp className="text-[14px]" />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default GetEarlyAccess;